import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const procore = defineConnector({
  identifier: "procore",
  name: "Procore",
  tagLine: "Construction project management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.procore\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Procore instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Procore instance.",
        },
        {
          kind: "input",
          label: "Company ID",
          placeholder: "598134325779301",
          required: true,
          target: { kind: "configuration", field: "companyId" },
          helperText: "Your Procore company ID",
        },
      ],
    },
    {
      title: "Create a Procore app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Procore Developer Portal](https://developers.procore.com/) and navigate to **My Apps** to create a new application and configure your OAuth credentials.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/procore/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Procore account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Procore account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://login.procore.com/oauth/authorize",
    tokenEndpoint: () => "https://login.procore.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.procore.com/rest/v1.0/me",
  },
});
